module.exports = __webpack_public_path__ + "static/media/_GPX0992.704797a3.jpeg";